import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-assets', 'labelMore', 'Show more');
Labels.set('ui-assets', 'labelLess', 'Show less');
Labels.set(
    'ui-assets',
    'labelToggleContent',
    'Currently {visibleAssets} of {allAssets} list items visible.'
);
